// import {
//   Circle,
//   // GoogleMap,
//   withGoogleMap,
//   withScriptjs,
//   Marker,
//   Polyline
// } from "react-google-maps";
import React, { useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker, Polyline } from '@react-google-maps/api'
import { Google_Map_Key } from '../config';
import MarkerComponent from './Marker';

function Map(props) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: Google_Map_Key,
    nonce: "map",
    libraries: ["places"],
  });

  return (
    <div>
      {isLoaded &&
        <GoogleMap
          zoom={props.detail && props.detail.pickup ? 14 : 12}
          center={{ 
            lat: props.detail && props.detail.pickup ? parseFloat(props.detail.pickup.lat) : 9.925067, 
            lng: props.detail && props.detail.pickup ? parseFloat(props.detail.pickup.lng) : 78.118863 
          }}
          mapContainerStyle={{ width: '100%', height: '550px' }}
        >
          {/* {props.detail && props.radius ?
            <Circle
              defaultCenter={{
                lat: parseFloat(props.detail.pickup.lat),
                lng: parseFloat(props.detail.pickup.lng)
              }}
              radius={props.radius}
              options={{ strokeColor: "grey", strokeWeight: 2 }}
            /> : null} */}
          {props.detail?.pickup &&
            <Marker
              position={{ lat: props.detail?.pickup?.lat, lng: props.detail?.pickup?.lng }}
            />
          }
          {props.detail?.drop &&
            <Marker
              position={{ lat: props.detail?.drop?.lat, lng: props.detail?.drop?.lng }}
            />
          }
          {props.wayPoints?.length > 0 &&
            <Polyline
              path={props.wayPoints}
              options={{
                strokeColor: "#414bf8",
                strokeOpacity: 0.8
              }}
            // strokeWeight={2} 
            />
          }
          {props.locations?.map(marker => {
            var path = [];
            // let obj1 = {
            //   lat: marker.oldlat ? marker.oldlat : marker.lat,
            //   lng: marker.oldlng ? marker.oldlng : marker.lng,
            // }
            let obj2 = {
              lat: marker.lat,
              lng: marker.lng
            }
            // path.push(obj1);
            path.push(obj2);
            return (<MarkerComponent key={marker.id} locations={path} marker={marker} />);
          })}

        </GoogleMap>
      }
    </div>
  );
}

export default React.memo(Map)

// const MapComponent = withScriptjs(withGoogleMap(Map));

// export default MapComponent;
